import { useCallback } from 'react';

import { ORDER_BY_OPTIONS, OrderByOption } from 'constants/orderBy';

function readOrderBy(storageKey: string, urlParam: string): OrderByOption {
  const stored = localStorage.getItem(storageKey) as OrderByOption | null;
  if (stored && Object.values(ORDER_BY_OPTIONS).includes(stored)) {
    return stored;
  }

  const params = new URLSearchParams(window.location.search);
  const urlValue = params.get(urlParam) as OrderByOption | null;
  if (urlValue && Object.values(ORDER_BY_OPTIONS).includes(urlValue)) {
    return urlValue;
  }

  return ORDER_BY_OPTIONS.DEFAULT;
}

export function usePersistedOrderBy(
  storageKey: string,
  urlParam: string,
): {
  orderBy: OrderByOption;
  setOrderBy: (value: OrderByOption) => void;
} {
  const orderBy = readOrderBy(storageKey, urlParam);

  const setOrderBy = useCallback(
    (value: OrderByOption) => {
      if (value && value !== ORDER_BY_OPTIONS.DEFAULT) {
        localStorage.setItem(storageKey, value);
      } else {
        localStorage.removeItem(storageKey);
      }

      const params = new URLSearchParams(window.location.search);
      if (value && value !== ORDER_BY_OPTIONS.DEFAULT) {
        params.set(urlParam, value);
      } else {
        params.delete(urlParam);
      }

      window.history.replaceState(
        null,
        '',
        params.toString()
          ? `${window.location.pathname}?${params}`
          : window.location.pathname,
      );
    },
    [storageKey, urlParam],
  );

  return { orderBy, setOrderBy };
}
